/**
 * 확인 필요 의약품 모달 — 레거시 ConfirmNeededDrugsModal 표시·키 헬퍼.
 */
import type {
  CommissionValidationItem,
  DrugCandidateSearchResult,
} from '@/entities/drug-data/api/drug-data.api';

export const EMPTY_CELL = '—';

export const CONFIRM_NEEDED_TAB_KEYS = {
  BASIC: 'basic',
  MFDS: 'mfds',
  MAPPING: 'mapping',
} as const;

export type ConfirmNeededTabKey =
  (typeof CONFIRM_NEEDED_TAB_KEYS)[keyof typeof CONFIRM_NEEDED_TAB_KEYS];

export function displayCell(value: unknown): string {
  if (value == null || value === '') return EMPTY_CELL;
  return String(value);
}

export function formatDelimitedMultiline(
  value: unknown,
  delimiter: string,
): string {
  if (value == null || value === '') return EMPTY_CELL;
  const parts = String(value)
    .split(delimiter)
    .map((part) => part.trim())
    .filter(Boolean);
  if (parts.length === 0) return EMPTY_CELL;
  return parts.join('\n');
}

export function resolvePharmaCompanyName(
  row: { pharmaCompanyName?: string } | null | undefined,
): string {
  return displayCell(row?.pharmaCompanyName);
}

export function resolveValidationPrice(
  row: {
    price?: unknown;
    pricePharma?: unknown;
    priceHira?: unknown;
  } | null | undefined,
): string {
  return displayCell(row?.price ?? row?.pricePharma ?? row?.priceHira);
}

export function resolveValidationPharmaDrugCode(
  row: {
    pharmaDrugCode?: unknown;
    drugCodePharma?: unknown;
    drugCode?: unknown;
  } | null | undefined,
): string {
  return displayCell(
    row?.pharmaDrugCode ?? row?.drugCodePharma ?? row?.drugCode,
  );
}

/** 정산 행 선택 시 후보 자동검색 — 의약품명 앞 3글자 */
export function buildSettlementDrugSearchKeyword(drugName: unknown): string {
  return String(drugName ?? '')
    .trim()
    .slice(0, 3);
}

export function isSettlementRowCreated(
  row: { status?: string } | null | undefined,
): boolean {
  return row?.status === 'CREATED';
}

export function candidateListCount(rows: unknown): number {
  return Array.isArray(rows) ? rows.length : 0;
}

export function countDrugCandidateResults(
  result: DrugCandidateSearchResult | null | undefined,
): number {
  if (!result) return 0;
  return (
    candidateListCount(result.drugBasicInfoCandidates) +
    candidateListCount(result.drugInfoMfdsCandidates) +
    candidateListCount(result.drugCodeMappingCandidates)
  );
}

export function validationRowKey(
  row: CommissionValidationItem,
  index: number,
): string {
  return `${row.drugCode ?? ''}_${row.pharmaCompanyId ?? ''}_${index}`;
}
